var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcOffice365 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 23.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7356 16.0542L27.6986 34.8214L11.337 32.9238C11.7109 32.6088 12.1863 32.5296 12.7264 32.3499C13.1926 32.1953 13.5573 32.0774 14.0166 31.9248C14.9098 31.6291 15.8353 31.2581 16.6708 31.0649L16.6731 18.2648L27.7356 16.0542ZM11 32.7576C11 32.7576 11.1431 32.8968 11.2839 32.9741C11.4408 33.0591 11.4847 33.0629 11.6601 33.1248C11.9232 33.2156 12.1979 33.289 12.4794 33.3721C13.0449 33.5344 13.5227 33.6948 14.0928 33.8745L23.7865 36.8736C28.0887 38.1374 26.8493 38.3499 30.4313 37.4494L35.5713 36.1895C36.4968 35.9596 36.9008 36.0176 37 35.6523V14.3459C36.813 14.0194 36.9077 14.1257 36.3284 13.9846L33.748 13.3624C32.617 13.0938 31.4861 12.8116 30.3229 12.5218C29.0788 12.2126 28.0679 11.7585 26.9139 12.1546L11 17.1402V32.7576Z",
    fill: "#EB3B00"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcOffice365, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_office 365.86d0b66b.svg";
export { ForwardRef as ReactComponent };